module.exports = __webpack_public_path__ + "static/media/lizhizhengming1.c7029449.png";